import { PayloadAction } from '@reduxjs/toolkit'
import { captureError } from 'utils/errorTracker'

export const PREFIX = 'REDUX_WEBSOCKET'
export const createType = (text: string): string => `${PREFIX}::${text.toUpperCase()}`

/**
 * Take payload of https://github.com/giantmachines/redux-websocket structure:
 *      {
 *        type: 'REDUX_WEBSOCKET::MESSAGE',
 *        meta: {
 *            timestamp: Date,
 *        },
 *        payload: {
 *            message: string,  // json formatted string
 *            origin: string,
 *        },
 *      }
 *
 * Take out the message, convert it to json and pass it to reducers with structure:
 *      {
 *          user: 1
 *          type: "REDUX_WEBSOCKET::USER_JOINED_CHAT"
 *      }
 */
const parsePayload = (action: PayloadAction<{ message: string }, string>) => {
    try {
        const json = JSON.parse(action.payload.message)
        json.type = createType(json.type)
        return json
    } catch (e) {
        captureError(e)
        return action
    }
}

const INCOMING_MESSAGE = createType('MESSAGE')

export default () => (next) => (action: PayloadAction<{ message: string }, string>) => {
    if (action.type !== INCOMING_MESSAGE) {
        return next(action)
    }

    const parsed = parsePayload(action)
    if (parsed) {
        return next(parsed)
    }
    return next(action)
}
